module.exports = __webpack_public_path__ + "img/select-default-exhibit.0f4ec8cb.png";